export const SET_DARK_MODE = 'SET_DARK_MODE';
export const SET_IN_VIEW = 'SET_IN_VIEW';
export const RESET_APP_STATE = 'RESET_APP_STATE';